import { render } from "./RoomInviteModal.vue?vue&type=template&id=1cb53c0e&scoped=true"
import script from "./RoomInviteModal.vue?vue&type=script&lang=js"
export * from "./RoomInviteModal.vue?vue&type=script&lang=js"

import "./RoomInviteModal.vue?vue&type=style&index=0&id=1cb53c0e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cb53c0e"]])

export default __exports__